<button
  [type]="btnType"
  [class]="class"
  [disabled]="disabled"
  (click)="clickMethod()"
  (mouseenter)="changeMethod()"
>
  <app-svg-icon
    *ngIf="buttonIconBeforeTextPath"
    [class]="buttonIconBeforeTextCss"
    [name]="buttonIconBeforeTextPath"
    alt=""
  >
  </app-svg-icon>

  {{ innerText }}

  <app-svg-icon
    *ngIf="buttonIconAfterTextPath"
    [class]="buttonIconAfterTextCss"
    [name]="buttonIconAfterTextPath"
    alt=""
  >
  </app-svg-icon>

  <img *ngIf="isImage" [src]="onlyImagePath" alt="" [class]="isImageClass" />
  
  <ng-content></ng-content>
</button>
